import type { ComponentPropsWithoutRef, CSSProperties } from "react";

type ImageProps = Omit<ComponentPropsWithoutRef<"img">, "style"> & {
  fill?: boolean;
  priority?: boolean;
  sizes?: string;
  style?: CSSProperties;
};

export default function Image({
  fill = false,
  priority = false,
  style,
  loading,
  ...props
}: ImageProps) {
  return (
    <img
      {...props}
      loading={priority ? "eager" : loading}
      style={
        fill
          ? {
              position: "absolute",
              inset: 0,
              width: "100%",
              height: "100%",
              objectFit: "cover",
              ...style,
            }
          : style
      }
    />
  );
}
